import styled from 'styled-components'

const GAP = '1.5em'
const PAGE_GUTTER = 'clamp(1rem, 4vw, 3rem)'
const DEFAULT_ASPECT_RATIO = '2.7 / 3'
const COMPACT_ASPECT_RATIO = '1 / 1'

export const Slide = styled.section`
  display: flex;
  flex-direction: column;
  width: calc(100% + (${PAGE_GUTTER} * 2));
  margin-inline: calc(${PAGE_GUTTER} * -1);
  /* padding-inline: ${PAGE_GUTTER}; */
  box-sizing: border-box;
`

export const SectionTitle = styled.h2`
  margin: 0;
  font-family: 'Chivo', sans-serif;
  font-size: 1.9rem;
  font-weight: 600;
  color: #fff;
  text-align: left;
  padding-left: 10px;
  font-style: italic;
  line-height: 2;
  text-transform: uppercase;
  text-shadow: 2px 1px 2px #000000;
`

export const CarouselWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
`

export const SlideViewport = styled.div`
  overflow: hidden;
  flex: 1;
  min-width: 0;
  padding: ${({ $size }) => ($size === 'sm' ? '0.5rem' : '1rem')}
    clamp(1rem, 2.5vw, 1.5rem);
  box-sizing: border-box;
  --gap: ${({ $size }) => ($size === 'sm' ? '0.75em' : GAP)};
  --visible-count: ${({ $visibleCount }) => $visibleCount};
  --card-aspect-ratio: ${({ $compactAspect }) =>
    $compactAspect ? COMPACT_ASPECT_RATIO : DEFAULT_ASPECT_RATIO};
  --slot-width: calc(
    (100% - (var(--visible-count) - 1) * var(--gap)) / var(--visible-count)
  );
`

export const SlideTrack = styled.div`
  display: flex;
  align-items: center;
  gap: var(--gap);
  --start-index: ${({ $startIndex }) => $startIndex};
  transition: transform 0.45s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transform: translateX(calc(-1 * var(--start-index) * (var(--slot-width) + var(--gap))));
  will-change: transform;
`

export const CardSlot = styled.div`
  position: relative;
  z-index: 0;
  flex: 0 0 var(--slot-width);
  width: var(--slot-width);
  min-width: var(--slot-width);
  aspect-ratio: var(--card-aspect-ratio, 2.7 / 3);

  article {
    position: relative;
    z-index: 0;
    width: 100%;
    max-width: none;
  }

  &:has(article:hover),
  &:has(article:focus-within) {
    z-index: 2;
  }
`

export const NavSpacer = styled.div`
  flex: 0 0 2.75rem;
  width: 2.75rem;
  height: 2.75rem;
`

export const NavButton = styled.button`
  flex: 0 0 2.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  /* width: 5.75rem; */
  /* height: 5.75rem; */
  padding: 0;
  border: none;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.72);
  color: #fff;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.45);

  i {
    font-size: 3.5rem;
    line-height: 1;
  }

  &:hover {
    /* background: rgba(120, 188, 40, 0.9); */
    transform: scale(1.08);
    color: #78bc28;
  }

  &:focus-visible {
    outline: 2px solid #78bc28;
    outline-offset: 2px;
  }
`
